<template>
    <div>
        <v-img v-if="image.orientation=='portrait'" 
               :src="localImgSrc" 
               class="image mx-auto portrait transparent" 
               @click="viewImage" title="Click to zoom" contain>
        </v-img>

        <!-- Updated: Uses dynamic :elevation prop instead of hardcoded class string -->
        <v-card v-if="image.orientation=='landscape'" 
                :elevation="image.elevation"
                :class="location=='left'?'image-card transparent':'image-card-right transparent'">
            <v-img :src="localImgSrc" class="image" @click="viewImage" title="Click to zoom"></v-img>
        </v-card>
        
        <v-dialog v-model="dialogPicViewer" fullscreen hide-overlay transition="dialog-bottom-transition">
            <image-viewer ref="picViewerRef" :image="image" :dialogPicViewer.sync="dialogPicViewer"></image-viewer>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogPicViewer: false,
            localImgSrc: '', // Changed from null to an empty string
        }
    },
    components: {
        'image-viewer': () => import('@/components/ImageViewer'),
    },
    methods: {
        viewImage() {
            this.$refs.picViewerRef.viewPic()
            this.dialogPicViewer = true
        },
        handleScroll() {    
            if (window.scrollY >= (this.section_pos - 300)) {
                // 2. Only update if it hasn't been loaded yet to avoid unnecessary re-renders
                if (this.image && this.image.fileName && !this.localImgSrc) {
                    this.localImgSrc = require(`@/assets/landing/${this.image.fileName}`);
                }
            }
        },
    },
    props: ['image', 'location', 'section_id', 'section_pos'],
    created() {
        window.addEventListener('scroll', this.handleScroll)
    },
    mounted() {
        // Optional: Trigger check on mount in case the image is already in view
        this.handleScroll(); 
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>
<style lang="scss">
.image-card {
    margin:30px;
    border-radius:5px;
}
.image-card-right {
    margin:30px;
    border-radius:5px;
}
.portrait {
    height:420px;
    width:260px;
}
.portrait-mobile {
    height:420px;
    width:260px;
    margin: 10px 0px 10px 0px
}
.image {
    width:100%;
    margin-top:-30px;
    cursor:pointer;
}
.portrait {
    height:440px;
    width:260px;
    margin:0px 0px 10px 0px;
}
</style>
